import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outstanding-payment',
  templateUrl: './outstanding-payment.component.html',
  styleUrls: ['./outstanding-payment.component.scss']
})
export class OutstandingPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
